import { isUndefined } from 'lodash-es';
import { v4 as uuidV4 } from 'uuid';
import { getStorage, patchStorage } from '../local-storage';
/**
 * Looks for a Consumer UUID in storage and creates one if it does not exist
 */
export async function getOrCreateId() {
    const storage = getStorage();
    let { id } = storage;
    if (isUndefined(id)) {
        id = uuidV4();
        patchStorage({ id });
    }
    return id;
}
